exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".HighlightedPhoto-d9fef8b7{display:inline-block;margin-right:10px;height:80px;width:80px;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"HighlightedPhoto": "HighlightedPhoto-d9fef8b7"
};